<template>
  <div>
    <div class="block">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
        <div class="box box-grey">
          <div class="columns">
            <div class="column is-2">
              <BInputWithValidation
                rules="required|max:10"
                type="text"
                label="Anrede"
                v-model="user.salutation"
              />
            </div>
            <div class="column">
              <BInputWithValidation
                rules="required|max:50"
                type="text"
                label="Vorname"
                v-model="user.first_name"
              />
            </div>
            <div class="column">
              <BInputWithValidation
                rules="required|max:50"
                type="text"
                label="Nachname"
                v-model="user.last_name"
              />
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <BInputWithValidation
                :disabled="!newUser"
                rules="required|email|max:100"
                type="email"
                label="E-Mail"
                v-model="user.email"
              />
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <BInputWithValidation
                rules="max:100"
                type="text"
                label="Abteilung"
                v-model="user.department"
              />
            </div>
            <div class="column">
              <BInputWithValidation
                :rules="{ max: 15, regex: /^\+?[0-9][0-9\s-]+[0-9]$/ }"
                type="text"
                label="Telefon"
                v-model="user.phone"
              />
            </div>
          </div>
          <div v-if="isPermited(['admin', 'org_admin'])" class="columns">
            <div class="column">
              <BSelectWithValidation
                rules="required|oneOf:admin,org_admin,user"
                label="Nutzer Typ"
                v-model="user.type"
                expanded
              >
                <option v-if="isPermited('admin')" value="admin">Admin</option>
                <option value="org_admin">Org. Admin</option>
                <option value="user">User</option>
              </BSelectWithValidation>
            </div>
          </div>
        </div>
        <div class="block" v-if="error">
          <b-message type="is-danger">
            <span v-html="error" />
          </b-message>
        </div>
        <div class="is-flex is-justify-content-end">
          <b-button
            type="is-gold"
            :disabled="invalid"
            @click="handleSubmit(submit)"
          >
            Speichern
          </b-button>
        </div>
      </ValidationObserver>
    </div>
    <div v-if="'id' in user && me.id === user.id" class="block">
      <div class="card">
        <div class="card-content">
          <div class="content">
            <b-field label="Wollen Sie ihr Passwort ändern?"></b-field>
            <b-button
              type="is-gold"
              tag="router-link"
              :to="{ name: 'Password' }"
              expanded
            >
              Passwort ändern
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';
import BSelectWithValidation from '@/components/inputs/BSelectWithValidation.vue';

// import Password from './Password.vue';

export default {
  name: 'UserSimple',
  components: {
    BInputWithValidation,
    BSelectWithValidation,
    // Password,
  },
  props: {
    user: {
      required: true,
    },
    newUser: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      passwordChange: {
        password: null,
        new_password: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'user/me',
      isPermited: 'user/isPermited',
      error: 'user/error',
    }),
  },
  methods: {
    submit() {
      const data = {
        id: this.user.id,
        salutation: this.user.salutation,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        department: this.user.department,
        phone: this.user.phone,
        type: this.user.type,
      };

      if (this.newUser) data.email = this.user.email;
      this.$emit('submit', data);
    },
  },
};
</script>
